/**
 * Every failure in this package is a programming error or a violated invariant,
 * never a recoverable runtime condition. Callers should not catch these; they
 * should not be able to produce them.
 */
export class LedgerError extends Error {
  override readonly name: string = 'LedgerError';
}

/** An amount was not a safe integer number of minor units. */
export class AmountError extends LedgerError {
  override readonly name = 'AmountError';
}

/** Two amounts in different currencies met. */
export class CurrencyMismatchError extends LedgerError {
  override readonly name = 'CurrencyMismatchError';
}

/*
 * `UnbalancedJournalError` was here and went with the journals.
 *
 * It carried the two totals that failed to meet, because the one thing you want
 * when a journal does not balance is both sides of the sum. There are no
 * journals: Creem is the record of money and this package no longer keeps
 * books.
 */

/** A rate was outside [0, 10000] basis points, or otherwise invalid. */
export class RateError extends LedgerError {
  override readonly name = 'RateError';
}

/** An allocation could not be performed exactly. */
export class AllocationError extends LedgerError {
  override readonly name = 'AllocationError';
}
